import React, { useEffect, Suspense } from "react";
import { graphql, PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { SummaryHubLinkQuery as SummaryHubLinkQueryType } from "__generated__/SummaryHubLinkQuery.graphql";

import ErrorContainer from "apps/components/ErrorContainer";
import { TranslationFn } from "lib/types";
import PropTypes from "prop-types";

const SummaryHubLinkQuery = graphql`
    query SummaryHubLinkQuery {
        me {
            id
            isHubAuth
        }
    }
`;

type Props = {
    queryRef: PreloadedQuery<SummaryHubLinkQueryType>;
};

const SummaryHubLinkContent = ({ queryRef }: Props, { t: _ }: { t: TranslationFn }) => {
    const { me } = usePreloadedQuery(SummaryHubLinkQuery, queryRef);

    if (!me.isHubAuth) return null;

    return (
        <a className="indigo-text-link" href="/hub">
            {_(`Back to ${"Hub"}`)}
        </a>
    );
};

SummaryHubLinkContent.contextTypes = {
    t: PropTypes.func,
};

const SummaryHubLinkWrapper = () => {
    const [queryRef, loadQuery, disposeQuery] =
        useQueryLoader<SummaryHubLinkQueryType>(SummaryHubLinkQuery);

    useEffect(() => {
        loadQuery({});
        return () => {
            disposeQuery();
        };
    }, [loadQuery, disposeQuery]);

    if (!queryRef) return null;

    return <SummaryHubLinkContent queryRef={queryRef} />;
};

const SummaryHubLink = () => (
    <ErrorContainer hideContainer fallback={null}>
        <Suspense fallback={null}>
            <SummaryHubLinkWrapper />
        </Suspense>
    </ErrorContainer>
);

export default SummaryHubLink;
